import { render, staticRenderFns } from "./traineeFacility.vue?vue&type=template&id=299911e6&scoped=true"
import script from "./traineeFacility.vue?vue&type=script&lang=js"
export * from "./traineeFacility.vue?vue&type=script&lang=js"
import style0 from "./traineeFacility.vue?vue&type=style&index=0&id=299911e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299911e6",
  null
  
)

export default component.exports